export default __webpack_public_path__ + "static/cruiselines-royal-activities-7-30deda4d182f29d545f0715cc972e2d6.jpg";